const timestampToDateInput = (timestamp) => {
    if (!timestamp) return null; // Handle null or undefined timestamp
    const date = timestamp.toDate(); // Convert Firebase Timestamp to JS Date
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
};

export default timestampToDateInput;